export const getToken = () => {
  return localStorage.getItem('authToken');
};

export const setToken = (token) => {
  localStorage.setItem('authToken', token);
};

export const removeToken = () => {
  localStorage.removeItem('authToken');
};

export const getRefreshToken = () => {
  return localStorage.getItem('refreshToken');
};

export const setRefreshToken = (token) => {
  localStorage.setItem('refreshToken', token);
};

export const removeRefreshToken = () => {
  localStorage.removeItem('refreshToken');
};

export const getUser = () => {
  const userStr = localStorage.getItem('user');
  return userStr ? JSON.parse(userStr) : null;
};

export const setUser = (user) => {
  localStorage.setItem('user', JSON.stringify(user));
};

export const removeUser = () => {
  localStorage.removeItem('user');
};

export const isAuthenticated = () => {
  return !!getToken();
};

export const getAuthState = () => {
  const token = getToken();
  const user = getUser();
  return {
    token,
    user
  };
};

export const isStudentAuthenticated = () => {
  const { token, user } = getAuthState();
  return !!token && !!user && user.role === 'student';
};

export const logout = () => {
  removeToken();
  removeUser();
  window.location.href = '/';
};

export const handleApiError = (error) => {
  // Check if it's an authentication error
  if (error.message === 'Invalid token' || error.message === 'Token expired' || 
      error.status === 401 || error.response?.status === 401) {
    logout();
    return true; // Indicates it was an auth error
  }
  return false; // Not an auth error
};

export const checkApiResponse = (response) => {
  // Check if response indicates authentication issue
  if (response.status === 401 || response.data?.message === 'Invalid token' || 
      response.data?.message === 'Token expired') {
    logout();
    return true; // Indicates it was an auth error
  }
  return false; // Not an auth error
};
